import google from './google.png';
import zillow from './zillow.png';
import map from './map.png';

export { google, zillow, map };
